import { useClientPortalAPI } from "@certn/api/src/useClientPortalAPI";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function TagsFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/apply-links/tags/options/"
  );

  return (
    <Picker
      isLoading={isLoading}
      label={t("Tags")}
      items={data}
      selectedKeys={params.tag_id?.split(",") || []}
      onSelectionChange={(keys) => setParam("tag_id", Array.from(keys))}
      selectionMode="multiple"
      showActionBar
      testID="apply-link-tags-filter"
    />
  );
}
